export const init = () => {
  if (document.querySelector('.js-video-loading')) {

    let allVideos = document.querySelectorAll(".js-video-loading");

    allVideos.forEach(function (cur) {
      cur.classList.add("active");
      if (cur.closest(".container")) {
        let curVideo = cur.closest(".container").getElementsByTagName("video")[0];
        console.log(curVideo);
        curVideo.addEventListener('loadeddata', () => {
          cur.classList.remove("active");
        });
      }
    });

  }
}